import { NgClass } from '@angular/common';
import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    input,
    model,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

type TextValue = string;
@Component({
    selector: 'ui-input-text',
    standalone: true,
    imports: [InputWrapperComponent, NgClass],
    templateUrl: './m020-c010-input-text.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputTextComponent), multi: true }],
})
export class InputTextComponent implements ControlValueAccessor {
    value = model<TextValue>();
    disabled = model(false);
    label = input('');
    type = input<'text' | 'email' | 'number'>();
    error = input(false, { transform: booleanAttribute });
    errorMsg = input<string>();
    placeholder = input('');

    focussed = signal(false);

    _onChange?: (value: TextValue) => void;
    _onTouch?: () => void;

    writeValue(value: TextValue): void {
        this.value.set(value);
    }
    registerOnChange(fn: (value: TextValue) => void) {
        this._onChange = fn;
    }
    registerOnTouched(fn: () => void) {
        this._onTouch = fn;
    }
    setDisabledState?(isDisabled: boolean) {
        this.disabled.set(isDisabled);
    }

    setValue(event: Event) {
        const value = (event.target as HTMLInputElement).value;

        this.value.set(value);
        this._onChange?.(value);
    }
}
